export type FieldTreePage = {
  rows: unknown[]
  next: string | null
  salvagedFromError: boolean
}

const isCategoryRow = (row: unknown): boolean => {
  if (!row || typeof row !== 'object') return false
  const record = row as { id?: unknown; api_name?: unknown }
  return typeof record.id === 'number' && typeof record.api_name === 'string'
}

const readCategoryPage = (
  payload: unknown
): { rows: unknown[]; next: string | null } | null => {
  if (Array.isArray(payload)) {
    return payload.every(isCategoryRow) ? { rows: payload, next: null } : null
  }
  if (!payload || typeof payload !== 'object') return null
  const record = payload as { results?: unknown; next?: unknown }
  if (!Array.isArray(record.results) || !record.results.every(isCategoryRow)) return null
  return {
    rows: record.results,
    next: typeof record.next === 'string' ? record.next : null,
  }
}

/** Reads a get-field-tree thunk result. A 400 whose body is a category page is usable. */
export const readFieldTreeThunkResult = (res: {
  meta?: { requestStatus?: string }
  payload?: unknown
} | null | undefined): FieldTreePage | null => {
  if (res?.meta?.requestStatus === 'rejected') {
    const axiosResponse = res.payload as { status?: unknown; data?: unknown } | undefined
    if (axiosResponse?.status !== 400) return null
    const page = readCategoryPage(axiosResponse.data)
    return page ? { ...page, salvagedFromError: true } : null
  }

  const page = readCategoryPage(res?.payload)
  return page ? { ...page, salvagedFromError: false } : null
}
